(function () {
  'use strict';

  var GROUP_ID = '6899985';
  var ROOT_ID = 'swatch-group' + GROUP_ID;
  var ICONS = {
    'Arizona Cardinals': 'https://cdn.starapps.studio/v2/apps/vsk/zubazcomet/groups/4985720/100/foco-x-zubaz-nfl-arizona-cardinals-zebra-2-collab-printed-backpack.webp',
    'Buffalo Bills': 'https://cdn.starapps.studio/v2/apps/vsk/zubazcomet/groups/4985720/100/foco-x-zubaz-nfl-buffalo-bills-zebra-2-collab-printed-backpack.webp',
    'Los Angeles Rams': 'https://cdn.starapps.studio/v2/apps/vsk/zubazcomet/groups/4985720/100/foco-x-zubaz-nfl-los-angeles-rams-zebra-2-collab-printed-backpack.webp',
    'Miami Dolphins': 'https://cdn.starapps.studio/v2/apps/vsk/zubazcomet/groups/4985720/100/foco-x-zubaz-nfl-miami-dolphins-zebra-2-collab-printed-backpack.webp',
    'New England Patriots': 'https://cdn.starapps.studio/v2/apps/vsk/zubazcomet/groups/4985720/100/foco-x-zubaz-nfl-new-england-patriots-zebra-2-collab-printed-backpack.webp',
    'New York Jets': 'https://cdn.starapps.studio/v2/apps/vsk/zubazcomet/groups/4985720/100/foco-x-zubaz-nfl-new-york-jets-zebra-2-collab-printed-backpack.webp',
    'San Francisco 49ers': 'https://cdn.starapps.studio/v2/apps/vsk/zubazcomet/groups/4985720/100/foco-x-zubaz-nfl-san-francisco-49ers-zebra-2-collab-printed-backpack.webp',
    'Seattle Seahawks': 'https://cdn.starapps.studio/v2/apps/vsk/zubazcomet/groups/4985720/100/foco-x-zubaz-nfl-seattle-seahawks-zebra-2-collab-printed-backpack.webp'
  };
  var TEAM_LABELS = Object.keys(ICONS);

  function injectStyle() {
    if (document.getElementById('zubaz-swatch-team-icons-style')) return;

    var style = document.createElement('style');
    style.id = 'zubaz-swatch-team-icons-style';
    style.textContent = [
      '#' + ROOT_ID + ' .zubaz-team-icon-fallback {',
      '  width: 41px;',
      '  height: 41px;',
      '  min-width: 41px;',
      '  display: inline-block;',
      '  background-position: center;',
      '  background-repeat: no-repeat;',
      '  background-size: contain;',
      '  vertical-align: middle;',
      '  margin-right: 10px;',
      '}',
      '#' + ROOT_ID + ' .zubaz-team-icon-host {',
      '  display: inline-flex !important;',
      '  align-items: center;',
      '}',
      '#' + ROOT_ID + ' li.zubaz-team-icon-host,',
      '#' + ROOT_ID + ' .swatch-view.zubaz-team-icon-host,',
      '#' + ROOT_ID + ' .swatch-group-selector.zubaz-team-icon-host {',
      '  display: flex !important;',
      '}',
      '#' + ROOT_ID + ' .zubaz-team-icon-host .zubaz-team-icon-fallback {',
      '  flex: 0 0 41px;',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function compactText(element) {
    return (element && element.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function hasUsefulNativeImage(container) {
    var existing = container.querySelector('.star-set-image:not(.zubaz-team-icon-fallback)');
    if (!existing) return false;
    var inlineBg = existing.style && existing.style.backgroundImage;
    var computedBg = window.getComputedStyle(existing).backgroundImage;
    return !!((inlineBg && inlineBg !== 'none') || (computedBg && computedBg !== 'none'));
  }

  function buildIcon(label) {
    var icon = document.createElement('span');
    icon.className = 'star-set-image zubaz-team-icon-fallback';
    icon.setAttribute('aria-hidden', 'true');
    icon.style.backgroundImage = 'url(' + ICONS[label] + ')';
    return icon;
  }

  function findHost(root, label) {
    var selector = [
      '.swatch-view',
      '.swatch-drop-down-inner',
      '.swatch-group-selector',
      'li',
      'button',
      '[role="button"]',
      'a',
      'span',
      'div'
    ].join(',');

    var candidates = Array.prototype.slice.call(root.querySelectorAll(selector)).filter(function (element) {
      var text = compactText(element);
      return text.indexOf(label) !== -1 && text.length <= 180;
    });

    candidates.sort(function (a, b) {
      return compactText(a).length - compactText(b).length;
    });

    var host = candidates[0];
    if (!host) return null;

    return host.closest('.swatch-view, .swatch-drop-down-inner, .swatch-group-selector, li, button, [role="button"], a') || host;
  }

  function ensureIcon(host, label) {
    if (!host || !label || !ICONS[label]) return;
    if (hasUsefulNativeImage(host)) return;

    var existing = host.querySelector(':scope > .zubaz-team-icon-fallback');
    if (existing) {
      existing.style.backgroundImage = 'url(' + ICONS[label] + ')';
      return;
    }

    host.classList.add('zubaz-team-icon-host');
    host.insertBefore(buildIcon(label), host.firstChild);
  }

  function applyIcons() {
    var root = document.getElementById(ROOT_ID);
    if (!root) return false;

    injectStyle();

    TEAM_LABELS.forEach(function (label) {
      ensureIcon(findHost(root, label), label);
    });

    return true;
  }

  function start() {
    applyIcons();

    var observer = new MutationObserver(function () {
      applyIcons();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      applyIcons();
      if (attempts > 60) window.clearInterval(timer);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();